export function getIntuitColours(){
  const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

  return DISTINCT
}
export function getIntuitConfig() {
  const groupsById = {


      


    intuit_aware: {
      type: "likert",
      label: "Awareness of Intuit",
      fulltext: "Before today, how familiar, if at all, were you with Intuit?",
      keys: [
        "intuit_aware__very_familiar_pred_n",
"intuit_aware__somewhat_familiar_pred_n" ,
"intuit_aware__not_very_familiar_pred_n",
"intuit_aware__not_at_all_familiar_pred_n",
"intuit_aware__dk_pred_n",
      ],
      labels: {
        "intuit_aware__very_familiar_pred_n": "Very familiar",
"intuit_aware__somewhat_familiar_pred_n": "Somewhat familiar" ,
"intuit_aware__not_very_familiar_pred_n": "Not very familiar",
"intuit_aware__not_at_all_familiar_pred_n": "Not at all familiar",
"intuit_aware__dk_pred_n": "Don't know"
      },
      polarity: {
        pos: [
          "intuit_aware__very_familiar_pred_n",
          "intuit_aware__somewhat_familiar_pred_n",
        ],
        neu: ["intuit_aware__dk_pred_n"],
        neg: [
          "intuit_aware__not_at_all_familiar_pred_n",
          "intuit_aware__not_very_familiar_pred_n",
        ],
      },
      schema:"single"
    },

  
    intuit_trust: {
      type: "likert",
      label: "Trust in Intuit",
      fulltext: "(If aware) How much do you trust Intuit?",
      keys: [
        "intuit_trust__great_deal_pred_n",
"intuit_trust__fair_amount_pred_n" ,
"intuit_trust__not_very_much_pred_n",
"intuit_trust__not_at_all_pred_n",
"intuit_trust__dk_pred_n",
      ],
      labels: {
        "intuit_trust__great_deal_pred_n": "A great deal",
"intuit_trust__fair_amount_pred_n": "A fair amount" ,
"intuit_trust__not_very_much_pred_n": "Not very much",
"intuit_trust__not_at_all_pred_n": "Not at all",
"intuit_trust__dk_pred_n": "Don't know"
      },
      polarity: {
        pos: [
          "intuit_trust__great_deal_pred_n",
          "intuit_trust__fair_amount_pred_n",
        ],
        neu: ["intuit_trust__dk_pred_n"],
        neg: [
          "intuit_trust__not_at_all_pred_n",
          "intuit_trust__not_very_much_pred_n",
        ],
      },
      schema:"single"
    },



  };

  
  return {  groupsById };
}
const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = g.full_labels?.[k] || g.labels?.[k] || k;

      if (!colors[k]) {
        if (g.colors?.[k]) {
          colors[k] = g.colors[k];               // ✅ keep explicit colors
        } else if (g.type === "likert") {
          colors[k] = baseColorForLikertKey(g, k); // ✅ fallback
        } else {
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }

  return { labels, colors };
}


export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

  export function baseColorForLikertKey(group, key) {
    const pol = group?.polarity || {};

    const tag = Object.entries(pol).find(([_, polKey]) => {
      if (Array.isArray(polKey)) return polKey.includes(key);
      return polKey === key;
    })?.[0];

    if (tag === "pos") return "#2E7D32";
    if (tag === "neg") return "#C62828";
    if (tag === "neu") return "#bab0ab"; // optional: distinguish neutral from fallback
    return "#6e6e6e";
  }

// Tab-as-config default export
export default {
  tab: "intuit",
  label: "Intuit",
  get metrics() { return getIntuitConfig().groupsById; },
};

